// Обработчик для серверных уведомлений о сообщениях чата
// Направление: server -> client
import emitter from "../../core/wsEmitter";
// Types
import type {
	IChatAssistantMessagePayload,
	IChatMessagePayload,
} from "../../../types/chat.type";
import type { ISessionMessage } from "../../../types/session.type";
// Actions
import { appendMessage } from "../../../store/slices/session.slice";
import { store } from "../../../store/store";
import { playMessageNotificationSound } from "../../../utils/playMessageNotificationSound";

emitter.on("chat.message", (data: IChatMessagePayload) => {
	// eslint-disable-next-line no-console
	console.log("incoming chat message", data);
});

emitter.on("assistant_message", (data: IChatAssistantMessagePayload) => {
	const dispatch = store.dispatch;
	const activeSessionId = store.getState().session.sessionId;
	// Фільтр за сесією: відповідь для іншого чата не додається в поточний.
	// Події без session_id (старі версії бекенда) — попередня поведінка.
	if (
		data.session_id &&
		activeSessionId !== null &&
		data.session_id !== activeSessionId
	) {
		return;
	}
	const payloadMessage: ISessionMessage = {
		content: data.content,
		meta: {
			event: "assistant_message",
			customer_id: "",
		},
		role: "assistant",
		ts: new Date().toISOString(),
		type: "message",
	};
	dispatch(appendMessage(payloadMessage));
	playMessageNotificationSound();
});
